import DataUtils from './DataUtils'
import MainProject from './MainProject'

function gcd(a: number, b: number): number {
  let x = Math.abs(a)
  let y = Math.abs(b)
  while (y) {
    const t = y
    y = x % y
    x = t
  }
  return x || 1
}

export function aspectScaleString(width: number, height: number): string {
  const g = gcd(width, height)
  return `${width / g}:${height / g}`
}

export type NewProjectResolution = {
  width: number
  height: number
}

/**
 * 新建工程默认内存模型：工程名、分辨率、工具数据版本与 DataUtils 对齐。
 */
export function buildDefaultMainProject(
  gameName: string,
  resolution: NewProjectResolution,
): MainProject {
  const mp = new MainProject()
  const name = gameName.trim() || '未命名工程'
  mp.storyTree.ProjectName = name

  const { width, height } = resolution
  mp.screenHash.width = width
  mp.screenHash.height = height
  mp.screenHash.scale = aspectScaleString(width, height)

  const ver = DataUtils.dataLatestVersion
  mp.dataVer = ver
  mp.projectConstant.dataVersion = ver
  DataUtils.dataVersion = ver

  return mp
}
